// extracted by mini-css-extract-plugin
module.exports = {"val":"Input_val__1ySs-","disease-controller":"Input_disease-controller__2uBvs"};